// extracted by mini-css-extract-plugin
export default {"container":"SwitchHospital_container__qlV-3","buttonContainer":"SwitchHospital_buttonContainer__0G7mq","tagDropdown":"SwitchHospital_tagDropdown__4yguq"};